import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/auth.context";

/**
 * Route guard that redirects users to change password page
 * if they are using the default password (first-time login)
 */
export default function PasswordChangeGuard() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#009A44] border-t-transparent"></div>
      </div>
    );
  }

  // Check if user needs to change password
  // Check both from user object and localStorage (in case user object hasn't updated)
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const requiresPasswordChange = user?.requiresPasswordChange || storedUser?.requiresPasswordChange;

  if (requiresPasswordChange) {
    return <Navigate to="/change-password?firstTime=true" replace />;
  }

  return <Outlet />;
}

